<template>
  <div class="question" v-if="!question.deleted && question.deleted !== true">
    <div class="question__avatar">
      <div class="question__avatar-img">
        <img :src="getImage(question.authorAvatar)" alt="" :title="`${question.authorName} ${question.authorSurname}`">
      </div>
    </div>
    <div class="question__header">
      <p class="question__author">{{ `${question.authorName} ${question.authorSurname}` }}</p>
      <div class="question__date">
        <p>{{ question.date }}</p>
      </div>
      <div v-if="question.assessment > 0" class="question__assessment">
        <span v-for="n in 5" :class="[{ 'rating-active-star-icon': checkRating(n) }, 'rating-star-icon']"></span>
      </div>
    </div>
    <div class="question__content-wrap">
      <div v-if="formEditQuestionShow">
        <form @submit.prevent="validationEdidQuestion()" class="review__form">
          <label for="response"></label>
          <textarea id="response"
                    v-model="formEditQuestion.question"
                    class="review__form-input review__form-input_not-mrb"
                    :class="{'questions__form-input_warn': v$.formEditQuestion.question.$error}"
                    placeholder=""></textarea>
          <div v-for="item in v$.formEditQuestion.question.$errors" class="reviews__form-warning"
               :class="[{'reviews__form-warning_active': item}, 'reviews__form-warning_active-question']">
            {{ item.$message }}
          </div>
          <div class="button-form button-form__wrapper">
            <button class="button-link button-link_not-border">
              Сохранить изменения
            </button>
            <button type="button" class="button-link button-link_not-border" @click="formEditQuestionShowOff">
              Отменить изменения
            </button>
          </div>
        </form>
        <AddedFile :review="question" :stateParentComponent="formEditQuestionShow" @addFiles="addFiles"
                   @deleteFile="deleteFile"></AddedFile>
      </div>
      <div class="question__content" v-else>
        <div class="question__body">
          <p class="question__body-content" v-html="question.question"></p>
        </div>
        <div class="question__footer">
          <div class="question__footer-buttons">
            <div class="question__button">
              <div v-if="question.moderated" class="question__footer-column">
                <Reactions :user="user" :reactions="question.reactions" @updateReactions="updateReactions"></Reactions>
                <div class="button-link" @click="toggleVisibilityFormResponse(false)">
                  {{ btnOpenFormResponse }}
                  <span v-bind:class="formAddResponseShow ? 'closeForm' : ''"></span>
                </div>
              </div>
              <p v-else class="question__footer-info">
                <IconBase icon-name="history" class="question__icon-history">
                  <IconHistory/>
                </IconBase>
                Ожидает модерации
              </p>
            </div>
            <div class="question__button question__button--status">
              <div class="question__status" v-if="user.isModerator">
                <IconBase :icon-name="question.moderated ? 'eye' : 'eye-off'" class="question__icon-status">
                  <IconEye v-if="question.moderated"/>
                  <IconEyeOff v-else/>
                </IconBase>
                {{ question.moderated ? "Виден всем" : "Вопрос скрыт" }}
              </div>
              <div v-if="user.isModerator || user.authorizedUser" class="button-dots"
                   @click="buttonPopupShow = !buttonPopupShow">
                <transition name="fade">
                  <div class="button-popup" v-show="buttonPopupShow">
                    <a v-if="user.isModerator" @click="markModerateQuestion"
                       class="button-popup__link button-popup__item">
                      <IconBase icon-name="alert-circle" class="button-popup__icon">
                        <IconAlertCircle/>
                      </IconBase>
                      {{ moderateMessage }}
                    </a>
                    <a v-if="user.uuid === question.user_uuid" class="button-popup__link button-popup__item"
                       @click="formEditQuestionShow = true">
                      <IconBase icon-name="pencil" class="button-popup__icon">
                        <IconPencil/>
                      </IconBase>
                      Редактировать
                    </a>
                    <a v-if="user.isModerator" @click="deleteEntity(question.uuid)"
                       class="button-popup__link button-popup__item">
                      <IconBase icon-name="delete" class="button-popup__icon">
                        <IconDelete/>
                      </IconBase>
                      Удалить
                    </a>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <AddedFile :review="question" :stateParentComponent="formEditQuestionShow"></AddedFile>
          <div v-if="formAddResponseShow">
            <form @submit.prevent="validationAddResponse()" class="review__form">
              <label for="response"></label>
              <textarea id="response"
                        v-model="formAddResponse.response"
                        class="review__form-input"
                        placeholder=""></textarea>
              <div v-for="item in v$.formAddResponse.response.$errors" class="reviews__form-warning"
                   :class="{'reviews__form-warning_active': item}">
                {{ item.$message }}
              </div>
              <button :disabled="isOnSubmit" class="button-red">Отправить ответ</button>
            </form>
          </div>
        </div>
      </div>
      <div class="question__responses">
        <ListResponses :user="user" :responses="question.responses" type="question"
                       @updateResponseToQuestion="updateResponseToQuestion" @markModerate="markModerate"
                       :formEditResponseShow="formEditResponseShow"
                       @openEditResponseForm="openEditResponseForm"
                       @deleteEntity="deleteEntity"
                       @onSubmit="onSubmit"
                       @closeForm="formEditResponseShowOff"></ListResponses>
      </div>
    </div>
  </div>
</template>

<script>
import avatarDefault from "@/assets/images/review-avatar-default.png";
import Response from "@/components/Response";
import ListResponses from "@/components/ListResponses";
import Reactions from "@/components/Reactions";
import IconBase from "@/components/icon/IconBase";
import IconPencil from "@/components/icon/icons/IconPencil";
import IconAlertCircle from "@/components/icon/icons/IconAlertCircle";
import IconDelete from "@/components/icon/icons/IconDelete";
import IconEye from "@/components/icon/icons/IconEye";
import IconEyeOff from "@/components/icon/icons/IconEyeOff";
import IconHistory from "@/components/icon/icons/IconHistory";
import AddedFile from "@/components/AddedFile/AddedFile";
import {useVuelidate} from '@vuelidate/core';
import {required, helpers} from '@vuelidate/validators';
import eventBus from "@/js/eventBus";
import axios from "axios";


export default {
  name      : "Question",
  props     : {
    question: Object,
    user    : {
      type   : Object,
      require: true
    },
  },
  components: {
    Response,
    ListResponses,
    Reactions,
    IconBase,
    IconPencil,
    IconAlertCircle,
    IconDelete,
    IconEye,
    IconEyeOff,
    IconHistory,
    AddedFile
  },
  data() {
    return {
      v$                  : useVuelidate(),
      authorizedUser      : this.user.authorizedUser,
      buttonPopupShow     : false,
      formAddResponseShow : false,
      formEditResponseShow: false,
      formEditQuestionShow: false,
      isOnSubmit          : false,
      formEditQuestion    : {
        question    : '',
        files       : [],
        delete_files: []
      },
      btnOpenFormResponse : this.user.authorizedUser ? 'Ответить' : 'Авторизоваться и ответить',
      formAddResponse     : {
        question: '',
        response: ''
      },
    }
  },
  validations: {
    formEditQuestion: {
      question: {
        required: helpers.withMessage("Задайте вопрос", required),
      }
    },
    formAddResponse : {
      response: {
        required: helpers.withMessage("Напишите ответ", required),
      }
    }
  },
  methods    : {
    checkRating(n) {
      return Math.round(this.question.assessment - n) >= 0
    },
    // для отображения изображений
    getImage(urlImg) {
      return urlImg.length === 0 ? avatarDefault : urlImg
    },
    toggleVisibilityFormResponse(showAddRespons) {
      if (this.user.authorizedUser) {
        if (this.formAddResponseShow || this.formEditResponseShow || this.formEditQuestionShow || showAddRespons) {
          this.formAddResponseShow = false
          this.btnOpenFormResponse = 'Ответить'
        } else {
          this.formAddResponseShow = true
          this.btnOpenFormResponse = 'Закрыть форму ответа'
        }

      } else {
        $('#f__auth').modal('show');
      }
    },
    onSubmit(dataForm, uuid, showAddRespons) {
      const data = {
        idReview: this.question.uuid,
        ...this.formAddResponse,
        ...this.formEditQuestion,
        ...dataForm
      }
      this.isOnSubmit = true;
      const forumData = this.$parent.forumData();

      data.product_id = forumData.product_id;

      const formData = new FormData();

      formData.append('sessid', this.user.sessid);

      for (let key in data) {
        if (Array.isArray(data[key])) {
          for (let i = 0; i <= data[key].length - 1; i++) {
            formData.append(`${key}[${i}]`, data[key][i]);
          }
        } else {
          formData.append(key, data[key]);
        }
      }

      const that = this;
      const uuidEditReview = that.formEditQuestionShow ? that.question.uuid : uuid ? uuid : '';

      if (!!uuid) {
        formData.append('parent_uuid', dataForm.parent_uuid);
        formData.append('response', dataForm.response);
      }

      axios
          .post(`/api/forum/v1/questions/${uuidEditReview}/`, formData, {
            headers        : {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials: true
          })
          .then(response => {
            that.isOnSubmit = false;
            const result = response.data;

            eventBus.$emit('info', response.data.message);

            this.formEditQuestion.files = [];
            this.formEditQuestion.delete_files = [];

            if (result) {
              that.toggleVisibilityFormResponse(showAddRespons);
              that.formAddResponse.response = '';
              that.$parent.loadQuestions();
              that.formEditResponseShow = false;
              that.formEditQuestionShow = false;
            }
          });
    },
    updateResponseToQuestion(responseData) {
      const formData = new FormData();

      formData.append('sessid', this.user.sessid);

      for (let key in responseData) {
        formData.append(key, responseData[key]);
      }

      // const that = this;

      axios
          .post('/api/forum/v1/like/', formData, {
            headers        : {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials: true
          })
          .then(response => {
            const result = response.data;

            if (!result) {
              // todo восстановить исходные значения
            }
          }).catch();
    },
    updateReactions(reactions) {
      const data = {
        idReview: this.question.uuid,
        ...reactions
      }
      const formData = new FormData();

      formData.append('sessid', this.user.sessid);

      for (let key in data) {
        formData.append(key, data[key]);
      }

      const that = this;

      axios
          .post('/api/forum/v1/like/', formData, {
            headers        : {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials: true
          })
          .then(response => {
            const result = response.data;

            if (!result) {
              // todo восстановить исходные значения
            }
          }).catch();
    },
    reactions() {
      return this.question.reactions;
    },
    markModerateQuestion() {
      this.$emit('markModerate', this.question.uuid);
      this.question.moderated = !this.question.moderated;
    },
    markModerate(uuid) {
      this.$emit('markModerate', uuid);
    },
    deleteEntity(uidInstance) {
      if (confirm('Удалить запись?')) {
        this.$emit('deleteEntity', uidInstance);
      }
    },
    openEditResponseForm(uidInstance) {
      this.formEditResponseShow = uidInstance;
    },
    formEditResponseShowOff() {
      this.formEditResponseShow = false;
    },
    formEditQuestionShowOff() {
      this.formEditQuestion.question = this.question.question_origin;
      this.formEditQuestion.delete_files = [];
      this.formEditQuestion.files = this.question.files;
      this.formEditQuestionShow = false;
    },
    addFiles(arrayFiles) {
      this.formEditQuestion.files = arrayFiles;
    },
    deleteFile(fileUuid) {
      if (!this.formEditQuestion.delete_files.includes(fileUuid)) {
        this.formEditQuestion.delete_files.push(fileUuid);
      }
    },
    validationEdidQuestion() {
      this.v$.formEditQuestion.$validate();
      if (!this.v$.formEditQuestion.$error) {
        this.v$.formEditQuestion.$reset();
        this.onSubmit();
      }
    },
    validationAddResponse() {
      this.v$.formAddResponse.$validate();
      if (!this.v$.formAddResponse.$error) {
        this.v$.formAddResponse.$reset();
        this.onSubmit();
      }
    }
  },
  computed   : {
    moderateMessage: function () {
      return this.question.moderated ? 'Скрыть' : 'Показать'
    }
  },
  mounted() {
    this.formEditQuestion.question = this.question.question_origin;
  }
}
</script>

<style scoped>

</style>